import React from 'react';

import { Flex, Progress } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { minifyNumber } from 'constants/numberMinifyHelper';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const PROGRESS_BAR_SIZE = {
  normal: 'normal',
  large: 'large',
};

const PROGRESS_BAR_SIZE_VALUE = {
  normal: '8px',
  large: '20px',
};

const TransientProps = ['color'];

const StyledProgressBar = styled(Progress, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  borderRadius: '4px',
  background: props?.backgroundColor || '#EAEAEA',
  width: '100%',
  position: 'relative',
  '& div': {
    background: props?.color,
  },
}));

const StyledTextLabel = styled(TextLabel, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  marginLeft: '4px',
  marginTop: '2px',
  userSelect: 'none',
  color: props.color,
}));

const ProgressBar = ({
  size = PROGRESS_BAR_SIZE.normal,
  value,
  color,
  text,
  textColor,
  textProps,
  showPercentage = false,
  /*
    adding following prop to control the width of percentage next to bar.
    60px might to be too much for certain use cases e.g. in goals the percentage
    is suppose to be 0 to 3 digits long (in almost all cases) 
  */
  percentageMinWidth = '60px',
  ...props
}) => {
  let height;
  switch (size) {
    case PROGRESS_BAR_SIZE.normal:
      height = PROGRESS_BAR_SIZE_VALUE.normal;
      break;
    case PROGRESS_BAR_SIZE.large:
      height = PROGRESS_BAR_SIZE_VALUE.large;
      break;
    default:
      console.error(`Error: Invalid size : ${size} . Pick one from [${Object.keys(PROGRESS_BAR_SIZE)}]`);
      height = PROGRESS_BAR_SIZE_VALUE.normal;
      break;
  }

  const progressValue = value < 0 ? 0 : value;

  return (
    <Flex w="100%">
      <Flex flexGrow={1}>
        <StyledProgressBar height={height} value={progressValue} color={color} {...props}>
          {text && (
            <StyledTextLabel color={textColor} bold {...textProps}>
              {text}
            </StyledTextLabel>
          )}
        </StyledProgressBar>
      </Flex>
      {showPercentage && (
        <TextBodyMedium sx={{ marginLeft: '4px', minWidth: percentageMinWidth }} bold>
          {minifyNumber(value)}%
        </TextBodyMedium>
      )}
    </Flex>
  );
};

export { ProgressBar };
